import React from 'react';
import {
  BookOpen, Wrench, BadgeCheck, ClipboardList, Briefcase, Building2, Crown, TrendingUp,
} from 'lucide-react';

const steps = [
  { icon: BookOpen, label: 'Education', desc: 'K-12 & post-secondary preparation' },
  { icon: Wrench, label: 'Training', desc: 'Skills & applied learning' },
  { icon: BadgeCheck, label: 'Industry Certifications', desc: 'Credentials that count' },
  { icon: ClipboardList, label: 'Work-Based Learning', desc: 'Real environments, real tools' },
  { icon: Briefcase, label: 'Internships', desc: 'On-ramps into the industry' },
  { icon: Building2, label: 'Employment', desc: 'Stable, family-sustaining jobs' },
  { icon: Crown, label: 'Leadership', desc: 'From frontline to executive' },
  { icon: TrendingUp, label: 'Economic Mobility', desc: 'Generational impact' },
];

export const WorkforceJourney = () => {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="overline text-aawta-magenta">The Workforce Journey</span>
          <h2 className="font-display font-bold text-4xl md:text-5xl mt-4 text-aawta-navy tracking-tight leading-[1.1]">
            From classroom to leadership — one connected pathway.
          </h2>
          <div className="divider-magenta mt-6" />
          <p className="mt-6 text-[17px] leading-relaxed text-aawta-muted">
            Every stage matters. Our Collaborative aligns educators, employers, and community
            partners so no learner falls between the cracks — and every worker has a real
            path to leadership and economic mobility.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* Connector line on desktop */}
          <div className="hidden lg:block absolute left-0 right-0 top-[46px] h-px bg-gradient-to-r from-transparent via-aawta-border to-transparent" />

          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <li
                  key={s.label}
                  data-testid={`journey-step-${i + 1}`}
                  className="relative reveal"
                  style={{ animationDelay: `${i * 70}ms` }}
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="relative">
                      <div className="w-[92px] h-[92px] rounded-2xl bg-white border border-aawta-border shadow-aawta-soft flex items-center justify-center relative z-10 group-hover:shadow-aawta-elevated transition-shadow duration-300">
                        <Icon className="h-8 w-8 text-aawta-navy" strokeWidth={1.8} />
                      </div>
                      <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-aawta-magenta text-white text-xs font-bold flex items-center justify-center z-20 shadow-aawta-magenta">
                        {i + 1}
                      </div>
                    </div>
                    <h3 className="mt-5 font-display font-semibold text-lg text-aawta-navy">
                      {s.label}
                    </h3>
                    <p className="mt-1 text-sm text-aawta-muted max-w-[200px]">{s.desc}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default WorkforceJourney;
